import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';
const SvgAddUserOutline = ({
  alt = 'Add Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}
    <path
      fill="currentColor"
      d="M8.4 12a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6Zm0-7.8c1.654 0 3 1.346 3 3 0 1.655-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3Zm1.901 9.6H6.5A6.5 6.5 0 0 0 0 20.3a1.3 1.3 0 0 0 1.3 1.3h14.2a1.3 1.3 0 0 0 1.299-1.3 6.5 6.5 0 0 0-6.499-6.5Zm-8.474 6a4.704 4.704 0 0 1 4.672-4.2H10.3c2.423 0 4.392 1.843 4.673 4.2H1.827ZM23.1 9.9h-1.8V8.1a.9.9 0 0 0-1.8 0v1.8h-1.8c-.495 0-.9.405-.9.9s.403.9.9.9h1.8v1.8a.9.9 0 0 0 1.8 0v-1.8h1.8c.499 0 .9-.4.9-.9 0-.498-.401-.9-.9-.9Z"
    />
  </svg>
);
export default SvgAddUserOutline;
